module.exports = __webpack_public_path__ + "static/oscar-cdfb45ee9c9ea3d2318b88a6cff709cc.jpg";